export default {
    dashboard: 'Dashboard',
    events: 'Události',
    ticketsets: 'Sady vstupenek',
    tickets: 'Vstupenky',
    zones: 'Zóny',
    verifyTicket: 'Ověřit vstupenku',
    devices: 'Zařízení',
    statistics: 'Statistiky',
    users: 'Uživatelé',
    clipboard: 'Schránka',
    help: 'Nápověda',
    groups: {
        overview: 'Přehledy',
        tickets: 'Vstupenky',
        settings: 'Nastavení'
    },
    auth: {
        login: 'Přihlášení',
        logout: 'Odhlásit'
    }
}
